import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

const useStyles = makeStyles({
  message: {
    fontSize: '12px',
  },
  root: {
    paddingBottom: '13px',
    paddingTop: '10px',
  },
});

export const ApiSaveErrorNotification = ({ message }) => {
  const styles = useStyles();

  return (
    <MessageBar className={styles.root} intent="error">
      <MessageBarBody>
        <span className={styles.message}>{message}</span>
      </MessageBarBody>
    </MessageBar>
  );
};

ApiSaveErrorNotification.propTypes = {
  message: PropTypes.string.isRequired,
};
